import { observer } from 'mobx-react-lite'
import { Box, Grid, Group } from '@mantine/core'
import { AppBadge, AppCard, AppSkeleton, AppText } from '../../app/common/ui'
import { useStore } from '../../app/stores/store'
import { EmptyState, AmmoScoreBadge, StatCard } from '../../app/common/ui'
import { formatDistanceToNow } from 'date-fns'

export default observer(function ModeratorSummaryTab () {
  const { moderationStore } = useStore()
  const { moderatorSummary, loadingSummary } = moderationStore

  if (loadingSummary && moderatorSummary.length === 0) {
    return (
      <Grid>
        {[1, 2].map((i) => (
          <Grid.Col key={i} span={6}>
            <AppSkeleton height={180} radius="md" />
          </Grid.Col>
        ))}
      </Grid>
    )
  }

  if (moderatorSummary.length === 0) {
    return (
      <EmptyState
        title="No moderators"
        message="No active moderator roles have been granted."
        action={{ label: 'Grant a role', onClick: () => {} }}
      />
    )
  }

  return (
    <Box>
      <Grid>
        {moderatorSummary.map((mod) => (
          <Grid.Col key={mod.userId} span={6}>
            <AppCard shadow="sm" padding="md" radius="md" withBorder>
              <Group position="apart" mb="xs">
                <Group spacing="xs">
                  <AppText weight={600}>@{mod.username}</AppText>
                  <AmmoScoreBadge tier={mod.ammoTier} score={mod.ammoScore ?? 0} size="sm" />
                </Group>
                {mod.flagsResolved === 0 && (
                  <AppBadge color="yellow" size="sm" variant="light">
                    No recent activity
                  </AppBadge>
                )}
              </Group>
              <AppText size="sm" color="dimmed" mb="sm">
                Scope: {mod.scope}
              </AppText>
              <Group spacing="md" mb="sm">
                <StatCard label="Flags Resolved" value={mod.flagsResolved} />
                <StatCard label="Avg Hours" value={mod.avgHoursToResolution.toFixed(1)} />
              </Group>
              <AppText size="xs" color="dimmed" mb={4}>
                Dismiss: {mod.countDismiss} · Warn: {mod.countWarn} · Remove: {mod.countRemove} · Escalate: {mod.countEscalate}
              </AppText>
              <AppText size="xs" color="dimmed">
                Last action: {mod.lastActionAt ? formatDistanceToNow(new Date(mod.lastActionAt), { addSuffix: true }) : 'No recent activity'}
              </AppText>
            </AppCard>
          </Grid.Col>
        ))}
      </Grid>
      <AppText size="sm" color="dimmed" mt="lg">
        Summary covers the last 30 days. Includes all users with active moderator roles and all admin users.
      </AppText>
    </Box>
  )
})
